// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__R0mbm","itemTitle":"ClientEmergencyInfo_itemTitle__1_9bw","itemText":"ClientEmergencyInfo_itemText__1AYJZ"};